export default {
  navText: '항해',
};
